import React, { lazy } from 'react';
import ElectronBlankSreenIcon from '@/assets/images/menu/icon-electron-blank-screen.react.svg?react';
import ElectronSessionIcon from '@/assets/images/menu/icon-electron-session.react.svg?react';
import ElectronApiIcon from '@/assets/images/menu/icon-hippy-api.react.svg?react';
import ElectronErrorIcon from '@/assets/images/menu/icon-hippy-error.react.svg?react';
import ElectronEventIcon from '@/assets/images/menu/icon-hippy-event.react.svg?react';
import ElectronLogIcon from '@/assets/images/menu/icon-hippy-log.react.svg?react';
import ElectronPerfIcon from '@/assets/images/menu/icon-hippy-perf.react.svg?react';
import ElectronPvIcon from '@/assets/images/menu/icon-hippy-pv.react.svg?react';
import ElectronSpeedIcon from '@/assets/images/menu/icon-hippy-speed.react.svg?react';
import ElectronStaticIcon from '@/assets/images/menu/icon-hippy-static.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const webRoutes = (): IRouteConfig[] => ([
  {
    path: '/web/error',
    name: '错误',
    icon: <MenuIcon icon={ElectronErrorIcon} fontSize={16} />,
    routes: [
      {
        path: '/web/error/dashboard',
        name: '概览',
        component: lazy(() => import('@/presentation/pages/web/error')),
      },
      {
        path: '/web/error/issues/list',
        name: '问题列表',
        component: lazy(() => import('@/presentation/pages/web/error-issues/issues/list')),
      },
      {
        path: '/exception/web-js-promise-error/issues/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/web/error-issues/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
    ],
  },
  {
    path: '/web/api',
    name: 'API监控',
    icon: <MenuIcon icon={ElectronApiIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/web/api')),
  },
  {
    path: '/performance',
    name: '性能监控',
    icon: <MenuIcon icon={ElectronPerfIcon} fontSize={16} />,
    platforms: [CapitalPlatform.Web],
    routes: [
      {
        path: '/web/perf',
        name: '页面性能',
        component: lazy(() => import('@/presentation/pages/web/perf')),
      },
      {
        path: '/web/load',
        name: '页面加载',
        component: lazy(() => import('@/presentation/pages/web/load')),
      },
    ],
  },
  {
    path: '/web/blank-screen',
    name: '白屏检测',
    icon: <MenuIcon icon={ElectronBlankSreenIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/web/blank-screen')),
  },
  {
    path: '/web/pv',
    name: '页面访问',
    icon: <MenuIcon icon={ElectronPvIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/web/pv')),
  },
  {
    path: '/web/static',
    name: '静态资源',
    icon: <MenuIcon icon={ElectronStaticIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/web/static')),
  },
  {
    path: '/web/session/detail',
    name: '会话详情',
    component: lazy(() => import('@/presentation/pages/web/session/detail')),
    hideInMenu: true,
  },
  {
    path: '/web/session',
    name: '会话追踪',
    icon: <MenuIcon icon={ElectronSessionIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/web/session')),
  },
  {
    path: '/web/event',
    name: '自定义事件',
    icon: <MenuIcon icon={ElectronEventIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/web/event')),
  },
  {
    path: '/web/custom',
    name: '自定义测速',
    icon: <MenuIcon icon={ElectronSpeedIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/web/custom')),
  },
  {
    path: '/web/log',
    name: '用户分析',
    component: lazy(() => import('@/presentation/pages/web/log')),
    icon: <MenuIcon icon={ElectronLogIcon} fontSize={16} />,
  },
]).map((route, index) => ({
  ...route,
  platforms: [CapitalPlatform.Web],
  sort: 99 - index,
}));

export default webRoutes;
